var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BasicIconMessage',{attrs:{"icon":_vm.icon,"iconColor":"error","messageColor":"error","action":_vm.buttonText,"actionColor":"error"},on:{"action":function($event){return _vm.emitReload()}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }